export default __webpack_public_path__ + "117fca6d39eb7a59827b3b9effa5d56a.svg";